<template>
  <div class="homePage">
    <!-- 移动端标题 -->
    <div class="screen-box2">
      <div class="left">{{ $t("common.latestNews.allAnnouncements") }}</div>
    </div>

    <!-- 移动端列表 -->
    <div class="list-box" ref="scrollContainer" @scroll="handleScroll">
      <div
        class="list-item"
        v-for="(item, index) in tableData2"
        :key="index"
        @click="goToDetail(item)"
      >
        <div class="line-box">
          <div class="title">{{ item.title }}</div>
        </div>
        <div class="line-box">
          <div class="content color1">{{ item.dateline | dateFormat }}</div>
        </div>
      </div>
      <div class="flag" v-if="!flag && tableData2.length !== 0">
        {{ $t("common.message.loadMore") }}
      </div>
      <div class="flag" v-if="flag && tableData2.length !== 0">{{ $t("common.message.noMoreData") }}</div>
      <el-empty
        v-if="tableData2.length === 0 && !loading"
        :description="$t('common.message.noData')"
      ></el-empty>
    </div>

    <!-- PC端表格 -->
    <div class="table-box">
      <div class="table-name">{{ $t("common.latestNews.allAnnouncements") }}</div>
      <el-table :data="tableData" height="820" border style="width: 100%">
        <el-table-column prop="dateline" :label="$t('common.latestNews.publishTime')" width="180">
          <template slot-scope="scope">
            {{ scope.row.dateline | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="title" :label="$t('common.latestNews.announcementTitle')" min-width="300">
        </el-table-column>
        <el-table-column :label="$t('common.latestNews.operation')" width="120" fixed="right">
          <template slot-scope="scope">
            <div class="view-btn" @click="goToDetail(scope.row)">{{ $t("common.latestNews.viewDetail") }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="getNewsList(1)"
          @current-change="getNewsList"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getNews } from "@/api/user";

export default {
  filters: {
    dateFormat(data) {
      if (!data) return "-";
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      // PC端表格数据
      tableData: [],
      page: 1,
      size: 10,
      total: 0,

      // 移动端列表数据
      flag: false,
      page2: 1,
      size2: 10,
      tableData2: [],
      loading: false,
    };
  },
  components: {},
  methods: {
    // 跳转到公告详情
    goToDetail(item) {
      this.$router.push({
        path: "/module/allNewDetails",
        query: { id: item.id },
      });
    },

    // 获取PC端数据
    getNewsList(type) {
      if (type) {
        this.page = type;
      }
      this.loading = true;
      getNews({
        page: this.page,
        size: this.size,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.tableData = res.data.list || [];
            this.total = res.data.dataCount || 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 获取移动端数据（滚动加载）
    getNewsList2(type) {
      console.log("ceshi1");
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }

      this.loading = true;
      console.log("ceshi2");
      getNews({
        page: this.page2,
        size: this.size2,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            const list = res.data.list || [];
            if (list.length > 0) {
              this.tableData2 = this.tableData2.concat(list);
              console.log("tableData2", this.tableData2);
              if (list.length === this.size2) {
                this.page2++;
              } else {
                this.flag = true;
              }
            } else {
              this.flag = true;
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 处理滚动事件
    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.getNewsList2();
      }
    },
  },
  created() {
    this.getNewsList();
    this.getNewsList2();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.homePage {
  min-height: calc(100vh - 60px);
  background-color: #f5f7fa;
  padding: 20px 140px;
}

// PC端表格样式
.table-box {
  height: 960px;
  margin-bottom: 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .table-name {
    font-size: 16px;
    color: #474f66;
    padding: 20px 0 20px 20px;
    font-weight: bolder;
  }

  .pagination-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 25px;
  }
}

.view-btn {
  color: #409eff;
  cursor: pointer;
  text-align: center;

  &:hover {
    text-decoration: underline;
  }
}

// 移动端标题
.screen-box2 {
  display: none;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  .left {
    font-size: 16px;
    color: #232323;
    font-weight: 600;
  }
}

// 移动端列表
.list-box {
  display: none;
  max-height: calc(100vh - 150px);
  overflow: auto;
  margin-top: 15px;
  margin-bottom: 25px;

  .list-item {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 17px 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    &:active {
      background: #f5f7fa;
    }

    .line-box {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #232323;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        line-height: 1.5;
      }

      .color1 {
        font-size: 13px;
        color: #999;
      }
    }
  }

  .flag {
    text-align: center;
    color: #999;
    font-size: 14px;
    padding: 15px 0;
  }
}
</style>

<style scoped>
.table-box >>> .el-table__header .el-table__cell {
  background-color: #fafbfc;
  color: #474f66;
  font-size: 14px;
  font-weight: bolder;
  text-align: center;
}

.table-box >>> .el-table__body .el-table__cell {
  text-align: center;
  color: #474f66;
  font-size: 14px;
}
</style>

<style lang="scss" scoped>
/* 媒体查询 - 平板端 */
@media only screen and (max-width: 1024px) {
  .homePage {
    padding: 20px 60px;
  }
}

/* 媒体查询 - 移动端 */
@media only screen and (max-width: 768px) {
  .homePage {
    padding: 15px;
    min-height: calc(100vh - 50px);
  }

  .table-box {
    display: none;
  }

  .screen-box2 {
    display: flex;
  }

  .list-box {
    display: block;
  }
}
</style>
